import React from 'react';
export function Footer() {
  return <footer className="bg-zinc-950 text-white py-8 md:py-10 px-4 border-t border-brand-green/30" data-id="element-82">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-83">
        <div className="inline-block bg-brand-green text-white font-display font-bold px-3 py-1.5 rounded-md mb-4 text-xs md:text-sm uppercase tracking-widest shadow-md" data-id="element-84">
          🐄 Sistema Pro Corrales Ganaderos™
        </div>

        <p className="text-base md:text-xl font-display italic mb-4 text-brand-greenLight max-w-xl" data-id="element-85">
          "La productividad también se construye."
        </p>

        <div className="border-t border-white/15 pt-4 mt-1 w-full max-w-md" data-id="element-86">
          <p className="text-[11px] md:text-xs text-white/50" data-id="element-87">
            © 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}